import {
  SET_PRODUCT_TAGS,
  SET_PRODUCT_TAG,
  SET_PRODUCT_TAGS_DETAILS,
  SET_PRODUCT_TAGS_LOADER,
  UPDATE_PRODUCT_TAG,
} from "../actionTypes/productTagsActionTypes";

const initialState: any = {
  productTags: [],
  productTagDetails: {},
  isLoading: false,
};

const productTagsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PRODUCT_TAGS_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_PRODUCT_TAGS:
      return {
        ...state,
        productTags: action.payload,
      };
    case SET_PRODUCT_TAG:
      return {
        ...state,
        productTags: [...state.productTags, ...action.payload],
      };
    case SET_PRODUCT_TAGS_DETAILS:
      return {
        ...state,
        productTagDetails: action.payload,
      };
    // Merges the saved tag back into the listing. Copying only `name` left the
    // row's image, status and priority stale until a page reload; the payload
    // is the full updated tag, so everything it carries is applied.
    case UPDATE_PRODUCT_TAG:
      return {
        ...state,
        productTags: (state.productTags || []).map((d: any) =>
          d.tagId === action.payload.tagId
            ? { ...d, ...action.payload }
            : d
        ),
      };
    default:
      return state;
  }
};

export default productTagsReducer;
